export const PopupTextOrg = (orgSelected: { type: string }): string => {
  if (orgSelected.type === 'Distributor') {
    return 'Contractor Management';
  } else {
    return 'Customer Management';
  }

  // will be used in the future for other org types
};